// extracted by mini-css-extract-plugin
export default {"page":"HgO7XO4f9trlPx89obyG","restrictWidth":"lMundmVuO36h0PL0lQDt"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"page\":\"HgO7XO4f9trlPx89obyG\",\"restrictWidth\":\"lMundmVuO36h0PL0lQDt\"}";
        // 1782821033668
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  